import classNames from "classnames"
import type { FC, ReactNode } from "react"
import { memo, useMemo } from "react"

interface Props {
  id?: string
  title?: {
    content: string | null | undefined
    variant: string | null | undefined
    color?: string | null | undefined
    headingLevel?: "h1" | "h2" | "h3" | "h4"
  }
  children?: ReactNode
}

const Layout: FC<Props> = memo(({ title, id, children }) => {
  const Title = title?.headingLevel ?? "h2"

  const titleClasses = useMemo(
    () =>
      classNames(
        "mb-8 text-center font-serif text-xl text-pretty lg:text-3xl",
        {
          "text-camp-capsule-page-text-light": title?.variant === "light"
        }
      ),
    [title?.variant]
  )

  const titleStyle = useMemo(
    () => ({
      color: title?.color ?? undefined
    }),
    [title?.color]
  )

  return (
    <div className="mx-auto max-w-camp-container-mobile px-4 lg:max-w-camp-container">
      {title && (
        <Title id={id} className={titleClasses} style={titleStyle}>
          {title.content}
        </Title>
      )}

      {children}
    </div>
  )
})

Layout.displayName = "Layout"

export default Layout
